import React from "react";

const ROWS = [
  ["financial_conversations", "Conversas financeiras"], ["links_sent", "Indicações do portal"],
  ["clients_with_link", "Clientes que receberam o link"], ["portal_opened", "Portal aberto (via WhatsApp)"],
  ["portal_logins", "Logins (via WhatsApp)"], ["clients_logged_after_link", "Clientes que entraram após o link"],
  ["access_issues", "Dificuldades de acesso"], ["handoffs", "Encaminhamentos à equipe"],
  ["resolved_without_human", "Resolvidas sem atendimento humano"], ["mixed", "Mensagens mistas (financeiro + compra)"],
  ["llm_fallbacks", "Respostas com texto-base (IA indisponível)"], ["open_handoffs", "Pendências abertas"],
];
const TOPIC = { saldo: "Quanto devo", produto: "Produto/compra", vencimento: "Vencimento", atraso: "Atrasos",
  pagamento: "Como pagar", ja_paguei: "Já paguei", recibo: "Recibos", limite: "Limite/score", historico: "Histórico" };

export const GuideMetrics = ({ m }) => (
  <section className="border border-[#EBE5DF] bg-white p-6" data-testid="wpg-metrics-section">
    <h2 className="text-lg font-semibold mb-1">Indicadores ({m.days} dias)</h2>
    <p className="text-xs text-[#5C5A57] mb-4">Link enviado não conta como acesso. Acesso e login só contam com evento real vindo do link do WhatsApp. Nenhum dado financeiro é registrado.</p>
    <dl className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {ROWS.map(([k, l]) => (
        <div key={k} className="bg-[#FBF8F5] p-3">
          <dt className="text-[11px] text-[#5C5A57]">{l}</dt>
          <dd className="text-xl font-semibold" data-testid={`wpg-metric-${k}`}>{m[k]}</dd>
        </div>
      ))}
    </dl>
    <div className="mt-4 flex flex-wrap gap-2" data-testid="wpg-top-topics">
      {m.top_topics.length === 0 && <span className="text-xs text-[#5C5A57]">Sem assuntos registrados.</span>}
      {m.top_topics.map((t) => (
        <span key={t.topic} className="rounded-full bg-[#F1EAF8] px-3 py-1 text-xs text-[#4C2380]">{TOPIC[t.topic] || t.topic}: {t.count}</span>
      ))}
    </div>
  </section>
);
